import React, {useMemo} from 'react';

import {Dialog, DialogBody, DialogFooter, Button, VF, Row, Col, Card, ModalComponentProps, makeValidate, Yup} from '@mc/ui-v4';

import {Form, FormRenderProps} from 'react-final-form';

type FormProps = {
    offset: number;
    length: number;
};

type Props = ModalComponentProps & {
    title: string;
    initialValues?: FormProps;
    maxOffset: number;
    onSubmit: (data: FormProps) => void;
};

/** * Modální dialog "Přidání polygonu rozměry" *
 * @param initialValues
 * @param title
 * @param onClose
 * @param onSubmit
 * @param initialValues
 *  @param onSubmit*/

export const PerpendicularLineModal: React.FC<Props> = ({title, initialValues, maxOffset, onClose, onSubmit}) => {
    const sizesSchema = Yup.object().shape({
        length: Yup.number().required('Zadejte délku v metrech').positive('Délka musí být větší než 0 m'),
        offset: Yup.number()
            .required('Zadejte odsazení v metrech')
            .positive('Odsazení musí být větší než 0 m')
            .max(maxOffset, `Odsazení musí být menší než ${maxOffset} m`),
    });
    const validate = useMemo(() => makeValidate(sizesSchema), []);

    return (
        <Form<FormProps>
            initialValues={initialValues}
            validate={async data => {
                return await validate(data);
            }}
            onSubmit={onSubmit}
        >
            {({submitting, handleSubmit}: FormRenderProps<FormProps>) => {
                return (
                    <Dialog isOpen onClose={onClose} title={title}>
                        <DialogBody>
                            <Card mode={'edit'} className="p-2">
                                <Row>
                                    <Col>{`Délka nakreslené přímky: ${maxOffset}(m)`}</Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <VF.Number key={'length'} disabled={submitting} name={'length'} label={'Délka (m)'} required={true} decimal />
                                    </Col>
                                    <Col>
                                        <VF.Number key={'offset'} disabled={submitting} name={'offset'} label={'Offset (m)'} required={true} decimal />
                                    </Col>
                                </Row>
                            </Card>
                        </DialogBody>
                        <DialogFooter>
                            <Button danger disabled={submitting} onClick={onClose}>
                                Zrušit
                            </Button>
                            <Button style="primary" disabled={submitting} onClick={handleSubmit} type={'submit'}>
                                Vytvořit
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
